import React from "react";
import styles from "../../styles/_containers/_reviews/reviewCard.module.scss";

export default function ReviewCard({ review, onToggleHide }) {
  const stars = "★".repeat(review.rating) + "☆".repeat(5 - review.rating);
  const date = new Date(review.createdAt).toLocaleDateString("he-IL");
  const name = review.userId?.name || "לקוח";

  return (
    <div className={`${styles.card} ${review.isHidden ? styles.hidden : ""}`}>
      <div className={styles.header}>
        <div className={styles.info}>
          <span className={styles.name}>{name}</span>
          <span className={styles.stars}>{stars}</span>
        </div>
        <div className={styles.actions}>
          <span className={styles.date}>{date}</span>
          <button
            className={styles.hideBtn}
            onClick={() => onToggleHide(review._id)}
            title={review.isHidden ? "הצג ביקורת" : "הסתר ביקורת"}
          >
            {review.isHidden ? (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                <line x1="1" y1="1" x2="23" y2="23"/>
              </svg>
            ) : (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
            )}
          </button>
        </div>
      </div>
      {review.text && <p className={styles.text}>{review.text}</p>}
      {review.isHidden && <span className={styles.hiddenBadge}>מוסתר מהציבור</span>}
    </div>
  );
}
